import React from "react";
import PropTypes from "prop-types";

import { cn } from "utils";

const sizeClasses = {
  xs: {
    wrapper: "h-7 w-7 rounded-sm",
    largeBuilding: "bottom-0 left-3 h-5 w-3",
    smallBuilding: "bottom-0 left-1.5 h-3 w-2",
  },
  sm: {
    wrapper: "h-10 w-10 rounded-sm",
    largeBuilding: "bottom-0 left-4 h-8 w-4",
    smallBuilding: "bottom-0 left-2 h-5 w-3",
  },
  md: {
    wrapper: "h-12 w-12 rounded-sm md:h-16 md:w-16",
    largeBuilding: "bottom-0 left-4 h-10 w-6 md:left-5 md:h-14 md:w-8",
    smallBuilding: "bottom-0 left-2 h-6 w-4 md:left-3 md:h-8 md:w-6",
  },
};

const CareerPlaceholder = ({ size }) => {
  const currentSize = sizeClasses[size];

  return (
    <div
      className={cn(
        "relative shrink-0 overflow-hidden bg-gray-200",
        currentSize.wrapper
      )}
    >
      <div className={cn("absolute bg-gray-400", currentSize.largeBuilding)} />
      <div
        className={cn(
          "absolute bg-gray-600 opacity-35",
          currentSize.smallBuilding
        )}
      />
    </div>
  );
};

CareerPlaceholder.propTypes = {
  size: PropTypes.oneOf(["xs", "sm", "md"]),
};

CareerPlaceholder.defaultProps = {
  size: "md",
};

export default CareerPlaceholder;
